import {
  AmendmentSummary,
  Contract,
  Contracts,
  Declaration,
} from '@/views/default';

import AmendmentConfirmation from '@/components/contracts/AmendmentConfirmation.vue';
import DynamicRouterView from '@/components/common/layout/DynamicRouterView.vue';

import { DynamicModal } from '@/views/modal';

const contracts = {
  path: 'contracts',
  components: {
    default: DynamicRouterView,
    modal: DynamicModal,
  },
  children: [
    {
      path: '',
      name: 'clientContracts',
      component: Contracts,
    },
    {
      path: 'confirmation',
      name: 'amendmentConfirmation',
      component: AmendmentConfirmation,
    },
    {
      path: ':id',
      name: 'clientContract',
      component: Contract,
    },
    {
      path: ':id/summary',
      name: 'clientAmendmentSummary',
      component: AmendmentSummary,
    },
    {
      path: ':id/declarations',
      name: 'clientDeclaration',
      component: Declaration,
    },
  ],
};

export default contracts;
